import GqlData from "../gql_data";

const categoryStartWith = (id: number): GqlData => {
    return {
        query: `query voyoCategory($id: Int!)
            {
                voyoCategory (id: $id) {
                    startWith { 
                        id foundIn 
                        episode { id meta { season } }
                        bookmark { percent }
                    }
                }
            }`,
        variables: { id }
    }
};

const voyoCategoryQuery = (id: number): GqlData => {
    return {
        query: `query voyoCategory($id: Int!)
            {
                voyoCategory (id: $id) {
                    id title url
                    meta {rootCategoryId}
                }
            }`,
        variables: { id }
    }
};

export { categoryStartWith, voyoCategoryQuery }